import * as yup from 'yup';

export default yup.object().shape({
  datasetSchema: yup.object().shape({ _id: yup.string().required() }),
  value: yup.object().required(),
});
